import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { DialogService } from 'src/app/_services/dialog.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { SmsTemplateService } from '../../_leadcrmservices/sms-template.service';
import { LeadService } from '../../_leadcrmservices/lead.service';


@Component({
  selector: 'app-sms-template',
  templateUrl: './sms-template.component.html',
  styleUrls: ['./sms-template.component.css']
})
export class SmsTemplateComponent implements OnInit {

  siteList = [];

  displayedColumns: string[] = ['SmsTemplateId', 'SiteTitle', 'TemplateName', 'TemplateContent', 'Status', 'Action'];

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  constructor(
    public smsTemplateService: SmsTemplateService,
    private titleService: Title,
    private dialog: MatDialog,
    private loading: LoadingService,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    public leadService: LeadService,
  ) { }

  ngOnInit() {
    this.onLoadSmsTemplates();
    this.onFetchSites();
  }

  onFetchSites() {
    var result = this.leadService.get_lead_binding_data().subscribe(data => {
      //console.log(data);
      this.siteList = data['site_list'];
      //console.log(this.siteList);
    });
  }


  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }

  onLoadSmsTemplates() {
    //console.log('ok');
    this.smsTemplateService.get_sms_templates().subscribe(data => {
      //console.log(data);
      this.dataSource = new MatTableDataSource<any>(data['smstemplateList']);
      this.dataSource.paginator = this.paginator;
      this.loading.spin$.next(false);
    });
  }

  onToggleSmsTemplateStatus(smstemplate_id) {
    this.dialogService.openConfirmDialog('Are you sure to want to continue ?').afterClosed().subscribe(res => {
      if (res) {
        this.loading.spin$.next(true);
        var result = this.smsTemplateService.toggle_site_smstemplate_status(smstemplate_id).subscribe(data => {
          //console.log(data);
          if (JSON.stringify(data['status']) == 'true') {
            //this.searchFormSubmit();           
            this.loading.spin$.next(false);
            this.notificationService.success(data['message']);
          }
          else {
            this.notificationService.error(JSON.stringify(data['error_message']));
            this.loading.spin$.next(false);
          }
        });
      }
    });
  }



  onCreate() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "35%";
    matDialogConfig.position = { top: '0px' }
    //this.dialog.open(CreateCompanyDialog, matDialogConfig);
    this.dialog.open(CreateSmsTemplateDialog, matDialogConfig).afterClosed().subscribe(res => {
      this.onLoadSmsTemplates();
    });
  }

  onEdit(rowData: any) {
    this.smsTemplateService.populateForm(rowData);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "35%";
    matDialogConfig.position = { top: '0px' };
    this.dialog.open(CreateSmsTemplateDialog, matDialogConfig).afterClosed().subscribe(res => {
      this.onLoadSmsTemplates();
    });
  }

}












/* Create SMS Template */

@Component({
  selector: 'create-sms-template-dialog',
  templateUrl: 'create-sms-template-dialog.html',
  styleUrls: ['./sms-template.component.css']
})
export class CreateSmsTemplateDialog {

  siteList: [];

  constructor(
    private dialogRef: MatDialogRef<SmsTemplateComponent>,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public smsTemplateService: SmsTemplateService,
    public leadService: LeadService,
  ) {
  }

  ngOnInit() {
    this.onFetchSites();
  }

  onFetchSites() {
    var result = this.leadService.get_lead_binding_data().subscribe(data => {
      //console.log(data);
      this.siteList = data['site_list'];
      //console.log(this.siteList);
    });
  }

  onClose() {
    this.smsTemplateService.sms_template_form.reset();
    this.dialogRef.close();
  }


  onSmsTemplateFormSubmit(formData: any) {
    //console.log(formData);
    if (this.smsTemplateService.sms_template_form.valid) {
      this.loading.spin$.next(true);
      if (!this.smsTemplateService.sms_template_form.controls['id'].value) {
        // Insert Data
        this.smsTemplateService.insert_sms_template(formData).subscribe(data => {
          //console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.smsTemplateService.sms_template_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error('SMS Template Data could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        //console.log('data updated');
        this.smsTemplateService.update_sms_template(formData).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.smsTemplateService.sms_template_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            console.log('error');
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }

    }
  }



}






